// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyModelResponse {
    static getAttributeTypeMap() {
        return PharmacyModelResponse.attributeTypeMap;
    }
}
PharmacyModelResponse.discriminator = undefined;
PharmacyModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyModel"
    }
];
//# sourceMappingURL=pharmacyModelResponse.js.map